/* eslint-disable arrow-body-style */

import useDownloadReport from "@saleor/hooks/useDownloadReport";
import { getCurrentTimestamp } from "@saleor/reports/utils/misc";
import { reportsDownload } from "@saleor/reports/utils/utils";
import _ from "lodash";
import moment from "moment-timezone";

import { BatchStatus } from "../../../types/globalTypes";
import { filterPayablesReportData, filterReportData } from "../utils";

export const formatDate = (date: string) => {
  return moment.tz(new Date(date), "Asia/Manila").format("MM/DD/YYYY");
};

export const formatDateWithTime = (date: string) => {
  return moment(date).format("LLL");
};

export const hasSelected = (selected: number) => selected <= 0;

export const getBatchStatusValue = (batchStatus: string) => {
  switch (batchStatus) {
    case BatchStatus.FOR_MANAGER_APPROVAL:
      return "For Manager's Approval";
    case BatchStatus.FOR_TREASURY_2_PROCESSING:
      return "For Treasury's Processing";
    case BatchStatus.FOR_TREASURY_APPROVAL:
      return "For Treasury's Approval";
    case BatchStatus.COMPLETED:
      return "Completed";
    case BatchStatus.PROCESSED:
      return "Processed";
    case BatchStatus.REJECTED:
      return "Rejected";
  }
};

export const getYear = (dateGeneratedYear: any) => {
  return moment.tz(new Date(dateGeneratedYear), "Asia/Manila").format("YYYY");
};

export const batchDetailsDownload = arr => {
  const groupedArr = Object.keys(_.groupBy(arr, "id"));

  return new Promise(resolve => {
    const val = filterReportData(
      _.groupBy(arr, "id")[Object.keys(_.groupBy(arr, "id"))[0]],
      reportsDownload.fnManagerFormat.fields
    ).map(item => {
      Object.entries(item).forEach(([key, value]) => {
        if (
          typeof value === "string" &&
          value?.includes(",") &&
          !value?.match(/^".*?"$/)
        ) {
          item[key] = `"${value}"`;
        }
      });

      return item;
    });

    const fileNameBatchId = Object.values(
      _.groupBy(arr, "id")[groupedArr[0]]
    )[0].id;
    const fileNameMallCode = Object.values(
      _.groupBy(arr, "id")[groupedArr[0]]
    )[0].mall_code;
    const fileNameYear = getYear(
      Object.values(_.groupBy(arr, "id")[groupedArr[0]])[0].created
    );
    useDownloadReport(
      val,
      reportsDownload.fnManagerFormat.fields,
      `${fileNameMallCode}_${fileNameYear}_${atob(fileNameBatchId)}`,
      `${fileNameMallCode}_${fileNameYear}_${atob(
        fileNameBatchId
      )}-${getCurrentTimestamp()}`,
      "csv"
    );

    resolve(true);
  });
};

export const payablesListDownload = (arr, groupBy, fields) => {
  const groupedArr = Object.keys(_.groupBy(arr, groupBy));

  return new Promise(resolve => {
    const val = filterPayablesReportData(
      _.groupBy(arr, groupBy)[Object.keys(_.groupBy(arr, groupBy))[0]],
      // reportsDownload.activeBatchPayouts.fields
      fields
    ).map(item => {
      Object.entries(item).forEach(([key, value]) => {
        if (
          typeof value === "string" &&
          value?.includes(",") &&
          !value?.match(/^".*?"$/)
        ) {
          item[key] = `"${value}"`;
        }
      });
      return item;
    });

    const fileNameBatchId = Object.values(
      _.groupBy(arr, "batch_id")[groupedArr[0]]
    )[0].id;
    const fileNameMallCode = Object.values(
      _.groupBy(arr, "batch_id")[groupedArr[0]]
    )[0].mall_code;
    const fileNameYear = getYear(
      Object.values(_.groupBy(arr, "batch_id")[groupedArr[0]])[0].date_generated
    );
    const settllementDate = moment(
      Object.values(_.groupBy(arr, "batch_id")[groupedArr[0]])[0]
        .settlement_date
    ).format("YYYYMMDDHHmmss");

    useDownloadReport(
      val,
      //   reportsDownload?.activeBatchPayouts?.fields,
      fields,
      `${fileNameMallCode}_${fileNameYear}_${atob(fileNameBatchId)}`,
      `GeneratePayablesList_${fileNameMallCode}_${settllementDate}`,
      "csv"
    );

    // checks if for loop iteration is done
    // ensures to call notify only once

    resolve(true);
  });
};
